// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `md-tabs.col-md-12 {
  padding: 28px 0 36px 0;
  display: inline-block;
}

md-tabs.md-default-theme .md-tab,
md-tabs .md-tab,
.md-tab {
  background-color: #fff;
}

md-tabs.col-md-12.instructor-nav .md-tab {
  color: #505050;
  font-size: 15px;
  padding: 0;
  text-decoration: underline;
  text-transform: capitalize;
}

md-tabs.col-md-12.instructor-nav2 .md-tab {
  color: #505050;
  font-size: 12px;
  padding: 0;
  text-decoration: underline;
  text-transform: capitalize;
}

md-tabs.col-md-12.instructor-nav .md-tab:not(:first-child):before {
  content: '|';
  color: black;
  display: inline-block;
  font-weight: 400;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  text-decoration: none !important;
}

md-tabs.col-md-12.instructor-nav .md-tab.md-active {
  font-weight: bold;
  border: none;
}
md-tabs.col-md-12.instructor-nav md-ink-bar {
  display: none;
}

md-tabs.col-md-12.instructor-nav md-tabs-wrapper {
  background-color: #fff;
  padding-left: 24px;
  border: none;
}
md-tabs.row.instructor-nav2 md-tabs-wrapper {
  background-color: #e0e0e0;
  height: 40px;
}
md-tabs.row.instructor-nav2 md-tabs-wrapper md-tab-item {
  background-color: #e0e0e0;
  line-height: 40px;
}
md-tabs.col-md-12.instructor-nav2 .md-tab {
  background-color: #e0e0e0;
  line-height: 40px;
}

md-tabs.col-md-12.instructor-nav2 md-tabs-wrapper {
  background-color: #e0e0e0;
  height: 40px;
  border: none;
}
md-tabs.col-md-12.instructor-nav2.md-dynamic-height {
  padding-top: 0;
}

md-pagination-wrapper {
  width: 999999px !important;
}

md-tabs.col-md-12 md-tabs-wrapper {
  background-color: #f8f8f0;
  padding: 0px;
}

.md-button {
  padding: 0px 30px;
}

.md-button span {
  color: #fff;
  padding: 0px;
}

.md-button.md-error:disabled {
  background-color: #ff0033;
}

md-dialog .md-actions,
md-dialog md-dialog-actions {
  padding: 0px 16px;
}

.panel-body {
  padding: 0px 0px 0px 30px;
}

.md-calendar-date:not(.md-disabled) .md-calendar-date-selection-indicator,
md-calendar-month
  .md-calendar-month-label:not(.md-calendar-month-label-disabled) {
  text-decoration: underline;
}

@media (min-width: 960px) {
  .md-padding {
    padding-top: 0;
  }
}

#taCal
  .md-calendar-date:not(.md-disabled)
  .md-calendar-date-selection-indicator {
  background: rgb(3, 169, 244);
  color: rgba(0, 0, 0, 0.87);
  border-color: transparent;
}

/* Rules to deal with modal always being positioned at top and fixed */
.md-dialog-is-showing {
  overflow: visible;
}

md-dialog,
md-dialog > form {
  display: block;
}

md-dialog .messaging {
  margin: 0px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/angular.material.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;;EAGE,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,sEAAsE;AACtE;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":["md-tabs.col-md-12 {\n  padding: 28px 0 36px 0;\n  display: inline-block;\n}\n\nmd-tabs.md-default-theme .md-tab,\nmd-tabs .md-tab,\n.md-tab {\n  background-color: #fff;\n}\n\nmd-tabs.col-md-12.instructor-nav .md-tab {\n  color: #505050;\n  font-size: 15px;\n  padding: 0;\n  text-decoration: underline;\n  text-transform: capitalize;\n}\n\nmd-tabs.col-md-12.instructor-nav2 .md-tab {\n  color: #505050;\n  font-size: 12px;\n  padding: 0;\n  text-decoration: underline;\n  text-transform: capitalize;\n}\n\nmd-tabs.col-md-12.instructor-nav .md-tab:not(:first-child):before {\n  content: '|';\n  color: black;\n  display: inline-block;\n  font-weight: 400;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n  text-decoration: none !important;\n}\n\nmd-tabs.col-md-12.instructor-nav .md-tab.md-active {\n  font-weight: bold;\n  border: none;\n}\nmd-tabs.col-md-12.instructor-nav md-ink-bar {\n  display: none;\n}\n\nmd-tabs.col-md-12.instructor-nav md-tabs-wrapper {\n  background-color: #fff;\n  padding-left: 24px;\n  border: none;\n}\nmd-tabs.row.instructor-nav2 md-tabs-wrapper {\n  background-color: #e0e0e0;\n  height: 40px;\n}\nmd-tabs.row.instructor-nav2 md-tabs-wrapper md-tab-item {\n  background-color: #e0e0e0;\n  line-height: 40px;\n}\nmd-tabs.col-md-12.instructor-nav2 .md-tab {\n  background-color: #e0e0e0;\n  line-height: 40px;\n}\n\nmd-tabs.col-md-12.instructor-nav2 md-tabs-wrapper {\n  background-color: #e0e0e0;\n  height: 40px;\n  border: none;\n}\nmd-tabs.col-md-12.instructor-nav2.md-dynamic-height {\n  padding-top: 0;\n}\n\nmd-pagination-wrapper {\n  width: 999999px !important;\n}\n\nmd-tabs.col-md-12 md-tabs-wrapper {\n  background-color: #f8f8f0;\n  padding: 0px;\n}\n\n.md-button {\n  padding: 0px 30px;\n}\n\n.md-button span {\n  color: #fff;\n  padding: 0px;\n}\n\n.md-button.md-error:disabled {\n  background-color: #ff0033;\n}\n\nmd-dialog .md-actions,\nmd-dialog md-dialog-actions {\n  padding: 0px 16px;\n}\n\n.panel-body {\n  padding: 0px 0px 0px 30px;\n}\n\n.md-calendar-date:not(.md-disabled) .md-calendar-date-selection-indicator,\nmd-calendar-month\n  .md-calendar-month-label:not(.md-calendar-month-label-disabled) {\n  text-decoration: underline;\n}\n\n@media (min-width: 960px) {\n  .md-padding {\n    padding-top: 0;\n  }\n}\n\n#taCal\n  .md-calendar-date:not(.md-disabled)\n  .md-calendar-date-selection-indicator {\n  background: rgb(3, 169, 244);\n  color: rgba(0, 0, 0, 0.87);\n  border-color: transparent;\n}\n\n/* Rules to deal with modal always being positioned at top and fixed */\n.md-dialog-is-showing {\n  overflow: visible;\n}\n\nmd-dialog,\nmd-dialog > form {\n  display: block;\n}\n\nmd-dialog .messaging {\n  margin: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
